<script setup>
import { Tooltip } from 'floating-vue';
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: String,
    required: true
  },
  placement: {
    type: String,
    default: 'top'
  },
  delay: {
    type: [Number, Object],
    required: false,
    default() {
      return { show: 400, hide: 0 };
    }
  },
  trigger: {
    type: String,
    required: false,
    default: 'hover'
  }
});

const showDelay = computed(() => {
  if (props.delay !== undefined) {
    if (typeof props.delay === 'number') {
      return props.delay;
    }

    if (typeof props.delay === 'object' && props.delay?.show) {
      return props.delay.show;
    }
  }

  return 400;
});

const hideDelay = computed(() => {
  if (props.delay) {
    if (typeof props.delay === 'number') {
      return props.delay;
    }

    if (typeof props.delay === 'object' && props.delay?.hide) {
      return props.delay.hide;
    }
  }

  return 0;
});
</script>

<template>
  <Tooltip
    inline
    :triggers="[`${trigger}`]"
    :placement="placement"
    :auto-hide="true"
    :delay="{ show: showDelay, hide: hideDelay }">
    <slot />

    <template #popper>
      <div v-html="content" />
    </template>
  </Tooltip>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';
@import 'floating-vue/dist/style.css';

/* trigger element */
div.v-popper {
  display: inline-block;
}

/* tooltip element */
.v-popper__popper.v-popper--theme-tooltip {
  --tooltip-background: @color-light;
  --tooltip-color: @color-mono-100;

  .v-popper__inner {
    .ms(-1);
    max-width: 480px;
    background: var(--tooltip-background);
    color: var(--tooltip-color);
    padding: @space-2;
    border-radius: @border-radius;

    a {
      color: inherit;
      text-decoration: underline;
    }

    p {
      &:not(:first-child) {
        margin-top: var(--space-2);
      }
    }
  }

  .v-popper__arrow-container {
    .v-popper__arrow-outer {
      border-color: var(--tooltip-background);
    }
  }
}
</style>
